if (typeof HTMLSlotElement.prototype.assignedElements === "undefined") {
    // eslint-disable-next-line func-names
    HTMLSlotElement.prototype.assignedElements = function (...args) {
        return HTMLSlotElement.prototype.assignedNodes.apply(this, args).filter((n: any) => n instanceof Element);
    };
}
